<div class="noselect">
    @if(groupAsset$ | async; as groupAsset) {
        @if (groupAsset.children.length > 0) {
            @if (groupAsset.children[index].asset_type === AssetType.Image) {
                <frog-image
                    #assetViewer
                    [asset]="groupAsset?.children[index]"
                    [preferences]="preferences"
                ></frog-image>
            }
            @if (groupAsset.children[index].asset_type === AssetType.Video) {
                <frog-video #assetViewer [asset]="groupAsset.children[index]"></frog-video>
            }
            @if (groupAsset.children[index].asset_type === AssetType.Marmoset) {
                <frog-marmoset #assetViewer [asset]="groupAsset.children[index]"></frog-marmoset>
            }
        }
    }
</div>

<div class="flex row align-center justify-center bottom nav-arrow">
    <button mat-icon-button color="primary" (click)="openContents()">
        <mat-icon>expand_more</mat-icon>
    </button>
</div>
